import { render, staticRenderFns } from "./ConfirmRegisterAndAddToVisitDialog.vue?vue&type=template&id=c2c90306&lang=pug&"
import script from "./ConfirmRegisterAndAddToVisitDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmRegisterAndAddToVisitDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports